// src/models/enums/UserRoleEnum.ts

/**
 * Permanent role of a user.
 * Never changed by lifecycle operations (freeze, delete, suspend, ban).
 * Used for permission checks and entry styling.
 *
 * - ROOKIE:    New user. Entries shown dimmed/grey. Cannot vote.
 * - AUTHOR:    Active writer. Full participation.
 * - MODERATOR: Can edit/delete entries, manage ROOKIE/AUTHOR users.
 * - ADMIN:     Full control.
 */
export enum UserRoleEnum {
  ROOKIE = "ROOKIE",
  AUTHOR = "AUTHOR",
  MODERATOR = "MODERATOR",
  ADMIN = "ADMIN",
}